import React from "react";
import {
  CaretRight,
  CaretLeft,
  CaretUp,
  CaretDown,
  Check,
  ArrowRight,
  ArrowSquareOut,
  Wrench,
  List,
  X,
} from "@phosphor-icons/react";

// Icon mapping for easy usage
const iconMap = {
  "chevron-right": CaretRight,
  "chevron-left": CaretLeft,
  "chevron-up": CaretUp,
  "chevron-down": CaretDown,
  check: Check,
  "arrow-forward": ArrowRight,
  "external-link": ArrowSquareOut,
  wrench: Wrench,
  menu: List,
  close: X,
};

// Icon component with size variants
export const Icon = ({
  name,
  size = "md",
  className = "",
  weight = "regular",
  ...props
}) => {
  const sizeClasses = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-5 h-5 sm:w-6 sm:h-6",
    xl: "w-8 h-8",
  };

  const IconComponent = iconMap[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <IconComponent
      className={`${sizeClasses[size]} ${className}`}
      weight={weight}
      {...props}
    />
  );
};
